import React from 'react';
import PropTypes, { shape } from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Dropdown, Image, Menu, Icon } from 'semantic-ui-react';

import Logout from './Logout';
import * as routes from '../routes.json';
import logo from '../static/twr360.png';

const Navigation = (props, { authUser }) => (
  <div>
    <Menu fixed="top" inverted>
      <Container>
        <Menu.Item as={Link} to={routes.home} header>
          <Image size="mini" src={logo} style={{ marginRight: '1.5em' }} />
          Webapps
        </Menu.Item>
        {authUser ? (
          <Menu.Menu position="right">
            <Dropdown item text="Menu">
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={routes.home}>
                  <Icon name="home" />
                  Home
                </Dropdown.Item>
                <Dropdown.Item as={Link} to={routes.account}>
                  <Icon name="user" />
                  Account
                </Dropdown.Item>
                <Logout />
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        ) : null}
      </Container>
    </Menu>
  </div>
);

Navigation.contextTypes = {
  authUser: PropTypes.object,
};

Navigation.propTypes = {
  authUser: shape(),
};

Navigation.defaultProps = {
  authUser: null,
};

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.jsx